import { TeacherInfoInputDTO } from '../../../src_server/entity/dto/TeacherInfoInputDTO';


import { TopPageTeacherDTO } from '../../../src_server/entity/dto/TopPageTeacherDTO';


import { LessonListDTO } from '../../../src_server/entity/dto/LessonListDTO';


import { LessonScheduleDTO } from '../../../src_server/entity/dto/LessonScheduleDTO';


import { DaLessonScheduleDTO } from '../../../src_server/entity/dto/DaLessonScheduleDTO';


import { Teacher } from '../../../src_server/entity/generated/Teacher';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';export class TeacherService extends GeneratedBizBase{
  async setTeacherInfo(dto: TeacherInfoInputDTO,building_id: string): Promise<Response<TeacherInfoInputDTO>> {
    return super.restCall<Response<TeacherInfoInputDTO>>('post', '/v1/teacher/setTeacherInfo', arguments);
  }
  async setAdditionalTeacherInfo(user_id: string,dto: TeacherInfoInputDTO,newPassword: string): Promise<Response<TeacherInfoInputDTO>> {
    return super.restCall<Response<TeacherInfoInputDTO>>('post', '/v1/teacher/setAdditionalTeacherInfo', arguments);
  }
  async setNewPassword(user_id: string,newPassword: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/teacher/setNewPassword', arguments);
  }
  async getCircleOTopPageTeachers(): Promise<Response<TopPageTeacherDTO[]>> {
    return super.restCall<Response<TopPageTeacherDTO[]>>('get', '/v1/teacher/getTopPageTeachers', arguments);
  }
  async getTeachers(building_id: string): Promise<Response<TeacherInfoInputDTO[]>> {
    return super.restCall<Response<TeacherInfoInputDTO[]>>('get', '/v1/teacher/getTeachers', arguments);
  }
  async getAllTeacherCandidateInfo(): Promise<Response<TeacherInfoInputDTO[]>> {
    return super.restCall<Response<TeacherInfoInputDTO[]>>('get', '/v1/teacher/getAllTeacherCandidateInfo', arguments);
  }
  async getFailureTeacherInfo(): Promise<Response<TeacherInfoInputDTO[]>> {
    return super.restCall<Response<TeacherInfoInputDTO[]>>('get', '/v1/teacher/getFailureTeacherInfo', arguments);
  }
  async sendFailureAnnounce(user_id: string,email: string,name: string): Promise<Response<any>> {
    return super.restCall<Response<any>>('post', '/v1/teacher/sendFailureAnnounce', arguments);
  }
  async getSuccessMailMessage(user_id: string,email: string,name: string,building_id: string): Promise<Response<any>> {
    return super.restCall<Response<any>>('get', '/v1/teacher/getSuccessMailMessage', arguments);
  }
  async sendSuccessCommit(user_id: string,building_id: string): Promise<Response<any>> {
    return super.restCall<Response<any>>('post', '/v1/teacher/sendSuccessCommit', arguments);
  }
  async getTeacherMatchingList(student_user_id: string,building: string): Promise<Response<LessonListDTO[]>> {
    return super.restCall<Response<LessonListDTO[]>>('get', '/v1/teacher/getTeacherMatchingList', arguments);
  }
  async getTeacherSchedules(teacher_user_id: string,student_user_id: string,start: string,end: string,building: string): Promise<Response<LessonScheduleDTO[]>> {
    return super.restCall<Response<LessonScheduleDTO[]>>('get', '/v1/teacher/getTeacherSchedules', arguments);
  }
  async getDaLessons(start: string,end: string,building: string): Promise<Response<DaLessonScheduleDTO[]>> {
    return super.restCall<Response<DaLessonScheduleDTO[]>>('get', '/v1/teacher/getDaLessons', arguments);
  }
  async getDaClassLessons(teacher_user_id: string,student_user_id: string,start: string,building: string): Promise<Response<DaLessonScheduleDTO[]>> {
    return super.restCall<Response<DaLessonScheduleDTO[]>>('get', '/v1/teacher/getDaClassLessons', arguments);
  }
  async getDaMatchingClass(building: string): Promise<Response<LessonListDTO[]>> {
    return super.restCall<Response<LessonListDTO[]>>('get', '/v1/teacher/getDaMatchingClass', arguments);
  }
  async getTeacherAllInfo(teacher_user_id: string): Promise<Response<LessonListDTO>> {
    return super.restCall<Response<LessonListDTO>>('get', '/v1/teacher/getTeacherAllInfo', arguments);
  }
  async getTeacher(teacher_user_id: string): Promise<Response<TeacherInfoInputDTO>> {
    return super.restCall<Response<TeacherInfoInputDTO>>('get', '/v1/teacher/getTeacher', arguments);
  }
  async maintenanceUpdate(teacher_user_id: string,dto: TeacherInfoInputDTO): Promise<Response<TeacherInfoInputDTO>> {
    return super.restCall<Response<TeacherInfoInputDTO>>('post', '/v1/teacher/maintenanceUpdate', arguments);
  }
  async completeDelete(teacher_user_id: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/teacher/completeDelete', arguments);
  }
  async updateTeacher(teacher: Teacher): Promise<Response<Teacher>> {
    return super.restCall<Response<Teacher>>('post', '/v1/teacher/updateTeacher', arguments);
  }
}
